import React from 'react';
import styled from 'styled-components';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  FiHome, 
  FiPackage, 
  FiGrid, 
  FiBarChart,
  FiSettings 
} from 'react-icons/fi';

const SidebarContainer = styled.aside`
  width: 250px;
  height: 100vh;
  background: white;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  
  @media (max-width: 768px) {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
`;

const Logo = styled.div`
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
  text-align: center;
`;

const LogoText = styled.h2`
  color: #ff0202;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0;
`;

const LogoSubtext = styled.p`
  color: #666;
  font-size: 0.8rem;
  margin: 0.2rem 0 0 0;
`;

const NavList = styled.nav`
  padding: 1rem 0;
`;

const NavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  color: #666;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  border-left: 3px solid transparent;

  &:hover {
    background: #f8f9fa;
    color: #ff0202;
  }

  &.active {
    background: #fff5f5;
    color: #ff0202;
    border-left-color: #ff0202;
  }

  svg {
    font-size: 1.1rem;
  }
`;

const menuItems = [
  {
    path: '/admin/dashboard',
    label: 'Dashboard',
    icon: FiHome
  },
  {
    path: '/admin/products',
    label: 'Ürünler',
    icon: FiPackage
  },
  {
    path: '/admin/categories',
    label: 'Kategoriler',
    icon: FiGrid
  },
  {
    path: '/admin/site-settings',
    label: 'Site Ayarları',
    icon: FiSettings
  },
];

export const AdminSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <SidebarContainer>
      <Logo>
        <LogoText>GALARAF</LogoText>
        <LogoSubtext>Admin Panel</LogoSubtext>
      </Logo>
      
      <NavList>
        {menuItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavItem 
              key={item.path}
              to={item.path}
              className={location.pathname === item.path ? 'active' : ''}
            >
              <Icon />
              {item.label}
            </NavItem>
          );
        })}
      </NavList>
    </SidebarContainer>
  );
};